// Real EL Well product photography. To update, replace /public/assets/bottle.png.
export function BottleVisual({ className = "" }) {
  return (
    <img
      src="/assets/bottle.png"
      alt="EL Well Magnesium Bisglycinate — 180 capsules in a premium black bottle"
      className={className}
      data-testid="bottle-visual"
      loading="lazy"
    />
  );
}
